"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildImageUrl = buildImageUrl;
// Crop around the image's stored Amplience point-of-interest metadata instead of
// the centre. Braces are %7B/%7D-encoded so the URL survives non-browser handling
// (new URL(), proxies); Amplience decodes and resolves the binding at delivery.
const POI_TRANSFORM = "scaleFit=poi&poi=" +
    "%7B$this.metadata.pointOfInterest.x%7D," +
    "%7B$this.metadata.pointOfInterest.y%7D," +
    "%7B$this.metadata.pointOfInterest.w%7D," +
    "%7B$this.metadata.pointOfInterest.h%7D";
function buildImageUrl(rawUrl, params = {}, { applyPoi = false, keepParams = false, } = {}) {
    // Console preview templates pass tokens (Console macros "{{ctImage}}" or the
    // client-template form "[[ctImage]]") in place of image URLs. These are not
    // valid URLs, so append the query string to the token rather than parsing it;
    // the preview substitutes a bare URL (query stripped) so the crop still
    // applies. Real image URLs never contain "{{" or "[[".
    if (rawUrl.includes("{{") || rawUrl.includes("[[")) {
        const query = new URLSearchParams(params).toString();
        const parts = [query, applyPoi ? POI_TRANSFORM : ""].filter(Boolean);
        return parts.length ? `${rawUrl.trim()}?${parts.join("&")}` : rawUrl;
    }
    const url = new URL(rawUrl.trim());
    // keepParams leaves the caller-supplied query string intact (large duplex is
    // handed a fully-built URL by the CMS); otherwise rebuild it from `params`.
    if (!keepParams)
        url.search = "";
    Object.entries(params).forEach(([key, value]) => {
        url.searchParams.set(key, value);
    });
    const result = url.toString();
    // Idempotent: never append a second scaleFit=poi if the URL already carries one.
    if (!applyPoi || result.includes("scaleFit=poi"))
        return result;
    return `${result}${url.search ? "&" : "?"}${POI_TRANSFORM}`;
}
